import { Helmet } from "react-helmet";
import "./post_thai.css";
import Pdf1 from './files/ผู้จัดการมรดก/แบบฟอร์มบัญชีเครือญาติ.pdf'
import Pdf2 from './files/ผู้จัดการมรดก/แบบฟอร์มหนังสือให้ความยินยอม.pdf'
import Doc1 from './files/ผู้จัดการมรดก/แบบฟอร์มบัญชีเครือญาติ.doc'
import Doc2 from './files/ผู้จัดการมรดก/แบบฟอร์มหนังสือให้ความยินยอม.doc'

const MainContent = () => {
  const TITLE = "ผู้จัดการมรดกคือใคร ใครสามารถเป็นได้บ้าง ?";
  return (
    <>
      <Helmet>
        <title>{TITLE}</title>
      </Helmet>

      <div className="content">
        <p>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<b>มรดก</b> คือ
          ทรัพย์สินของผู้ที่ถึงแก่กรรมตกถอดถึงทายาท
          ไม่ว่าจะเป็นอสังหาริมทรัพย์ในรูปแบบไหนก็ถือว่าเป็นมรดกเช่นกัน
          และการจะจัดการมรดก
          เพื่อแจกแจงหรือดำเนินการต่างๆในกองมรดกของเจ้ามรดกแล้วนั้น
          ก็ต้องมีผู้ทำหน้าที่อันสำคัญนี้คือ <b>ผู้จัดการมรดก</b>{" "}
          อันเป็นบุคคลที่ถูกแต่งตั้งขึ้นโดยพินัยกรรม หรือ
          คำสั่งศาลเห็นชอบสมควรให้มีสิทธิและหน้าที่ในการจัดการแจกแจงแบ่งทรัพย์มรดกให้ถูกต้อง
          โดยจะมีเงื่อนไขอะไรบ้างที่จะร้องขอต่อศาลเพื่อจัดตั้งผู้จัดการมรดกขึ้นมา
        </p>

        {/* 1. ใครเป็นผู้จัดการมรดกได้บ้าง ? */}
        <div>
          <h2 id="initial-header">
            1. ใครเป็นผู้จัดการมรดกได้บ้าง ?
          </h2>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<b>"ผู้จัดการมรดก"</b> คือ
            บุคคลซึ่งศาลมีคำสั่งตั้งเป็นผู้จัดการมรดก
            เพื่อทำหน้าที่รวบรวมทรัพย์สิน
            และแบ่งมรดกให้ทายาทผู้ที่มีสิทธิรับมรดก ซึ่ง
            <mark className=" bg-[#fee9b2] rounded-xl">
              ผู้จัดการมรดกไม่จำเป็นต้องเป็นทายาทของเจ้ามรดกจะเป็นใครก็ได้
            </mark>
          </p>

          <h3 id="second-header">
            1.1 ผู้ที่มีสิทธิร้องต่อศาลเพื่อขอจัดตั้งผู้จัดการมรดก
          </h3>
          <p className="ml-4">
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;ผู้ที่มีสิทธิร้องขอให้ศาลมีคำสั่งจัดตั้งผู้จัดการมรดกได้นั้นจะ
            ต้องเป็น{" "}
            <a className="text-indigo-700 underline" href="/thai/1">
              ทายาทของเจ้ามรดก
            </a>{" "}
            เช่น ผู้สืบสันดาน, บิดามารดา, พี่น้องร่วมบิดามารดาเดียวกัน ,
            คู่สมรส(ที่ทำการจดทะเบียนสมรสแล้วเท่านั้น)
            หรือจะเป็นบุคคลภายนอกก็ได้ แต่ต้องมีส่วนได้เสียร่วมกัน เช่น
            เจ้าของร่วมทรัพย์สิน
            <br />
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            หรือหากมีพินัยกรรมก็ให้เป็นไปตามที่พินัยกรรมได้ระบุไว้
            แต่ทั้งนี้ทั้งนั้น
            ศาลก็ไม่จำเป็นต้องจัดตั้งผู้จัดการมรดกตามพินัยกรรมระบุไว้ได้เช่นกัน
            อาจตั้งทายาทหรือผู้มีส่วนได้ส่วนเสียคนอื่นที่เหมาะสมกว่าก็ได้ และ
            <mark className=" bg-[#fee9b2] rounded-xl">
              การตั้งผู้จัดการมรดกไม่จำเป็นต้องแต่งตั้งขึ้นมาเพียงคนเดียว
              สามารถตั้งหลายคนก็ได้
            </mark>{" "}
            โดยถ้ามีผู้จัดการมรดกหลายคนการกระทำหน้าที่ของผู้จัดการมรดกนั้นต้องถือเอาเสียงข้างมาก
            เว้นแต่มีข้อกำหนดในพินัยกรรมเป็นอย่างอื่น
            ที่สามารถให้ผู้จัดการมรดกคนใดคนนึงสามารถเป็นผู้ดำเนินการเพียงลำพังได้
            ในขณะที่ผู้จัดการคนอื่นไม่สะดวก
          </p>

          <h3 id="third-header">1.2 ผู้ที่ไม่สามารถเป็นผู้จัดการมรดกได้</h3>
          <p className="ml-4">
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            ตามจริงแล้วหากมีคุณสมบัติเป็นทายาทหรือเป็นบุคคลที่มีส่วนได้เสียต่อเจ้ามรดกที่ถึงแก่กรรมไปแล้วก็สามารถได้รับการแต่งตั้งให้เป็นผู้จัดการมรดกได้หมด
            เว้นแต่บุคคลต่อไปนี้ ที่ไม่สามารถเป็นผู้จัดการมรดกได้ คือ
            <ul className=" list-decimal ml-12 mt-1">
              <li>ผู้ที่ยังไม่บรรลุนิติภาวะ อายุน้อยกว่า 20 ปีบริบูรณ์</li>
              <li>
                บุคคลวิกลจริต หรือบุคคล ที่ศาลสั่งให้เป็นผู้เสมือนไร้ความสามารถ
              </li>
              <li>บุคคลที่ศาลสั่งให้เป็นคนล้มละลาย</li>
            </ul>
          </p>
        </div>

        {/* 2. หน้าที่ของผู้จัดการมรดก */}
        <div>
          <h2 id="fourth-header">2. หน้าที่ของผู้จัดการมรดก</h2>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<b>ผู้จัดการมรดก</b>{" "}
            มีหน้าที่รวบรวม ทำบัญชี
            และแบ่งปันทรัพย์สินซึ่งเป็นมรดกของผู้ตายให้ทายาทผู้มีสิทธิรับมรดกของผู้ตาย
            และที่สำคัญ ผู้จัดการมรดก
            ต้องเป็นบุคคลซึ่งศาลมีคำสั่งตั้งให้เป็นผู้จัดการมรดก
            <br />
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<b>ผู้จัดการมรดก</b>{" "}
            มีสิทธิและหน้าที่ที่จะทำการอันจำเป็นเพื่อจัดการมรดกโดยทั่วไปและมีหน้าที่
            <mark className=" bg-[#fee9b2] rounded-xl">
              รวบรวมทรัพย์มรดกเพื่อแบ่งให้ทายาทโดยธรรมหรือผู้รับพินัยกรรม
              ตลอดจนชำระหนี้สินของเจ้ามรดกแก่เจ้าหนี้
            </mark>{" "}
            ทำบัญชีทรัพย์มรดก และทำรายการแสดงบัญชีการจัดการและแบ่งมรดก
            โดยต้องจัดการไปในทางที่เป็นประโยชน์แก่มรดก จะทำนิติกรรมใด ๆ
            ที่เป็นปรปักษ์ต่อกองมรดกไม่ได้
            <br />
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <mark className=" bg-[#fee9b2] rounded-xl">
              ถ้าหากผู้จัดการมรดกละเลยไม่ทำการตามหน้าที่
            </mark>{" "}
            เช่น ปิดบังมรดกต่อทายาท หรือเบียดบังเป็นของตน
            หรือเพิกเฉยไม่แบ่งมรดกให้แก่ทายาท
            <mark className=" bg-[#fee9b2] rounded-xl">
              ทายาทผู้มีสิทธิรับมรดกหรือผู้มีส่วนได้เสียสามารถร้องขอให้ศาลมีคำสั่งถอนผู้จัดการมรดกได้
            </mark>
            เพราะผู้จัดการมรดกละเลยไม่ทำตามหน้าที่หรือเพราะเหตุอย่างอื่นที่สมควรร้องต่อศาลก็ได้
            ซึ่งจะทำให้ผู้จัดการมรดกมีความผิดอาญามีโทษจำคุกได้
            <br />
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <b>หน้าที่ของผู้จัดการมรดกจะต้องทำตามขั้นตอน ต่อไปนี้</b>
            <ul className=" list-disc ml-16 mt-3">
              <li>
                จัดทำบัญชีทรัพย์มรดก <u>ภายใน 15 วัน</u> และ{" "}
                <u>ต้องจัดทำให้เสร็จภายใน 1 เดือน</u>{" "}
                หากไม่เสร็จสามารถขออนุญาตขยายระยะเวลาต่อศาลได้
              </li>
              <li>
                บัญชีทรัพย์มรดก ประกอบด้วย รายการแสดงทรัพย์สิน สิทธิเรียกร้อง
                เงิน มูลค่า และแจ้งจำนวนเจ้าหนี้ เป็นเงินรวมเท่าใด
              </li>
              <li>
                บัญชีทรัพย์มรดก <u>ต้องมีพยานรับรอง 2 คน</u>{" "}
                โดยต้องเป็นทายาทที่มีส่วนได้เสียในกองมรดก
              </li>
              <li>
                ถ้าไม่ได้จัดทำให้เสร็จภายในกำหนดเวลา และตามแบบที่กำหนด
                หรือบัญชีไม่เป็นที่พอใจแก่ศาล เพราะความประมาทเลินเล่อ
                อย่างร้ายแรง การทุจริต หรือความไม่สามารถของผู้จัดการมรดก
                ศาลจะถอนผู้จัดการมรดกได้
              </li>
              <li>
                <u>ผู้จัดการมรดกไม่มีสิทธิที่จะได้รับบำเหน็จจากกองมรดก</u>{" "}
                เว้นแต่พินัยกรรมหรือทายาทจำนวนข้างมากจะได้กำหนดไว้
              </li>
              <li>
                ผู้จัดการมรดกจะทำพินัยกรรมใดๆ ที่เป็นปฏิปักษ์ต่อกองมรดกไม่ได้
                เว้นแต่พินัยกรรมจะอนุญาตไว้หรือได้รับอนุญาตจากศาล
              </li>
              <li>ผู้จัดการมรดกต้องจัดการมรดกด้วยตนเอง</li>
              <li>
                ถ้าผู้จัดการมรดกเข้าทำนิติกรรมกับบุคคลภายนอก โดยเห็นแก่ทรัพย์สิน
                หรือประโยชน์อื่น ที่บุคคลภายนอกได้ให้
                หรือได้ให้คำมั่นว่าให้เป็นลาภส่วนตัว ย่อมไม่ผูกพันทายาท
                เว้นแต่ทายาทจะได้ยินยอมด้วย
              </li>
              <li>
                <u>
                  ต้องแจ้งให้ผู้มีส่วนได้เสียทราบถึงข้อกำหนดพินัยกรรม
                  ภายในเวลาอันสมควร
                </u>
              </li>
              <li>
                <u>
                  ทายาทจะต้องบอกทรัพย์สินมรดกและหนี้สินของผู้ตาย
                  ตามที่ตนรู้ทั้งหมดแก่ผู้จัดการมรดก
                </u>
              </li>
            </ul>
          </p>
        </div>

        {/* 3. เหตุใดบ้างที่ทำให้การผู้จัดการมรดกสิ้นสุดลง */}
        <div>
          <h2 id="fifth-header">
            3. ความสิ้นสุดของการเป็นผู้จัดการมรดก
          </h2>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;มีทั้งหมด 5 เหตุผล ดังนี้
            <ul className=" list-decimal ml-16 mt-3">
              <li>
                <b>เมื่อผู้จัดการมรดกตาย</b>
                <ul className=" list-disc ml-10 mt-3">
                  <li>
                    ผู้จัดการมรดกเป็นสิทธิเฉพาะตัวของผู้ได้รับการแต่งตั้ง
                    หากผู้จัดการมรดกตายก่อนจัดการมรดกเสร็จสิ้นจะต้องร้องขอตั้งผู้จัดการมรดกคนใหม่
                    และไม่สามารถเข้าเป็นคู่ความแทนที่ผู้มรณะได้
                  </li>
                  <li>
                    กรณีที่มี <b>ผู้จัดการมรดกหลายคน</b> เมื่อผู้จัดการคนใด
                    คนหนึ่งเสียชีวิต ผู้จัดการมรดกร่วมจะจัดการมรดกต่อไปไม่ได้
                    หากยังไม่ได้ขอให้ศาลมีคำสั่งอนุญาตให้ผู้จัดการที่เหลือเป็นผู้จัดการต่อไป
                    ดังนั้น
                    ผู้จัดการมรดกที่เหลือต้องร้องขอต่อศาลให้เปลี่ยนแปลงคำสั่งเดิมให้จัดการมรดกได้โดยลำพังก่อน
                  </li>
                </ul>
              </li>

              <li>
                <b>เมื่อผู้จัดการมรดกลาออก</b>
                <ul className=" list-disc ml-10 mt-3">
                  <li>
                    การลาออกจากการเป็นผู้จัดการมรดกจะมีผลต่อเมื่อได้รับอนุญาตจากศาลเท่านั้น
                  </li>
                  <li>
                    หากยังไม่ได้รับอนุญาตจากศาลให้ลาออกจากการเป็นผู้จัดการมรดก
                    ความเป็นผู้จัดการมรดกก็ยังไม่สิ้นสุดลง
                    หากมีความเสียหายเกิดขึ้น เพราะละเลย
                    ไม่ปฏิบัติตามหน้าที่ในระหว่างนี้
                    ผู้จัดการมรดกก็ต้องรับผิดชอบ
                  </li>
                </ul>
              </li>

              <li>
                <b>ศาลมีคำสั่งถอนผู้จัดการมรดก</b>{" "}
                โดยศาลได้รับคำร้องจากทายาทของเจ้ามรดก
              </li>

              <li>
                <b>ผู้จัดการมรดกตกเป็นบุคคลผู้มีคุณสมบัติต้องห้าม</b> เช่น
                บุคคลล้มละลาย บุคคลวิกลจริต หรือเสมือนไร้ความสามารถ
                ทำให้การเป็นผู้จัดการมรดกสิ้นสุดลงโดยอัตโนมัติ
              </li>

              <li>
                <b>เมื่อการจัดการมรดกสิ้นสุดลง</b>{" "}
                โดยนับตั้งแต่ผู้จัดการมรดกได้โอนมรดก "ทั้งหมด" ให้กับทายาทไป
                โดยเป็นการเริ่มนับอายุความจัดการมรดกจะอยู่ที่ 5 ปี
              </li>
            </ul>
          </p>
        </div>

        {/* 4. เอกสารประกอบการยื่นคำร้อง */}
        <div>
          <h2 id="sixth-header">4. เอกสารที่จำเป็นต้องใช้ในการแต่งตั้งผู้จัดการมรดก</h2>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;เอกสารที่ใช้ในการยื่นคำร้องเพื่อขอแต่งตั้งผู้จัดการมรดกมีทั้งหมด
            3 เอกสารหลัก ๆ มีดังนี้
          </p>

            <h3 id="seventh-header">4.1 เอกสารของเจ้ามรดก (ผู้ตาย)</h3>
            <p >
              <ul className=" list-decimal ml-16 mt-3">
                <li>สำเนาทะเบียนบ้าน (ประทับคำว่า "ตาย") --- <b>ต้นฉบับ 1 ชุด สำเนา 4 ชุด</b></li>
                <li>สำเนาใบมรณบัตร หรือ หนังสือรับรองการตาย --- <b>ต้นฉบับ 1 ชุด สำเนา 4 ชุด</b></li>
                <li>สำเนาใบสำคัญการสมรส/ใบสำคัญการหย่า --- <b>ต้นฉบับ 1 ชุด สำเนา 4 ชุด</b></li>
                <li>สำเนาหนังสือรับรองการเปลี่ยนชื่อตัว - ชื่อสกุล (หากมี) --- <b>ต้นฉบับ 1 ชุด สำเนา 4 ชุด</b></li>
                <li>สำเนาข้อมูลทะเบียนครอบครัว ทะเบียนสมรส, ทะเบียนรับรองบุตร, ทะเบียนรับรองบุตรบุญธรรม ออก ณ ที่ว่าการอำเภอ --- <b>ต้นฉบับ 1 ชุด สำเนา 4 ชุด</b></li>
                <li>พินัยกรรมของผู้ตาย (หากมี)</li>
              </ul>
            </p>


            <h3 id="eighth-header">4.2  เอกสารของผู้จะขอเป็นผู้จัดการมรดก</h3>
            <p>
              <ul className=" list-decimal ml-16 mt-3">
                <li>สำเนาทะเบียนบ้าน --- <b>ต้นฉบับ 1 ชุด สำเนา 4 ชุด</b></li>
                <li>สำเนาบัตรประจำตัวประชาชน --- <b>ต้นฉบับ 1 ชุด สำเนา 4 ชุด</b></li>
                <li>สำเนาใบสำคัญการสมรส (หากมี) --- <b>ต้นฉบับ 1 ชุด สำเนา 4 ชุด</b></li>
                <li>สำเนาใบสำคัญแสดงการเปลี่ยนชื่อตัว - ชื่อสกุล (หากมี) --- <b>ต้นฉบับ 1 ชุด สำเนา 4 ชุด</b></li>
              </ul>
            </p>

            <h3 id="ninth-header">4.3 เอกสารของทายาทโดยธรรมของเจ้ามรดกทุกคน (บิดา มารดา คู่สมรส บุตร ฯลฯ ของผู้ตาย)</h3>
            <p>
              <ul className=" list-decimal ml-16 mt-3">
                <li>สำเนาทะเบียนบ้าน --- <b>ต้นฉบับ 1 ชุด สำเนา 4 ชุด</b></li>
                <li>สำเนาบัตรประจำตัวประชาชน --- <b>ต้นฉบับ 1 ชุด สำเนา 4 ชุด</b></li>
                <li>สำเนาใบสำคัญการสมรส (หากมี)</li>
                <li>สำเนาใบสำคัญแสดงการเปลี่ยนชื่อตัว - ชื่อสกุล (หากมี) --- <b>ต้นฉบับ 1 ชุด สำเนา 4 ชุด</b></li>
                <li>สำเนาใบมรณบัตรของบิดา และ/หรือ มารดา ของเจ้ามรดก (กรณีเสียชีวิต) (หากไม่มี ต้องให้ที่ว่าการอำเภอออกหนังสือรับรองให้) --- <b>ต้นฉบับ 1 ชุด สำเนา 4 ชุด</b></li>
                <li>
                  <span>หนังสือให้ความยินยอมในการร้องขอจัดการมรดก</span>&nbsp;&nbsp;
                  <a className="text-indigo-700 underline" href= {Doc2}>ดาวน์โหลดไฟล์ Word</a>  | 
                  <a className="text-indigo-700 underline" href= {Pdf2} target="_blank">ดาวน์โหลดไฟล์ PDF</a>
                </li>
                <li>
                  <span>บัญชีเครือญาติ</span>&nbsp;&nbsp;
                  <a className="text-indigo-700 underline" href= {Doc1}>ดาวน์โหลดไฟล์ Word</a>  | 
                  <a className="text-indigo-700 underline" href= {Pdf1} target="_blank">ดาวน์โหลดไฟล์ PDF</a>
                </li>
              </ul>
            </p>

            <h3 id="tenth-header">4.4 เอกสารเกี่ยวกับทรัพย์สินของเจ้ามรดก</h3>
            <p>
              <ul className=" list-decimal ml-16 mt-3">
                <li>ทรัพย์สินที่ปรากฏชื่อของเจ้ามรดก เช่น โฉนดที่ดิน ทะเบียนรถ สมุดบัญชีธนาคาร ใบหุ้น ฯลฯ  --- <b>ต้นฉบับ 1 ชุด สำเนา 4 ชุด</b></li>
              </ul>
            </p>
            <br /><br />
            <div>
              <a className="post__ref">ขอบคุณแหล่งข้อมูล</a>
              <ul className="list__post">
                <li>
                  <a className="text-indigo-700 underline text-lg" target="_blank" href="https://www.thanulegal.com/16481396/%E0%B8%9C%E0%B8%B9%E0%B9%89%E0%B8%88%E0%B8%B1%E0%B8%94%E0%B8%81%E0%B8%B2%E0%B8%A3%E0%B8%A1%E0%B8%A3%E0%B8%94%E0%B8%81">
                    https://www.thanulegal.com/16481396/
                  </a>
                </li>
                <li>
                  <a className="text-indigo-700 underline text-lg" target="_blank" href="https://www1.ago.go.th/region4/wp-content/uploads/2022/03/r01.pdf">
                    https://www1.ago.go.th/region4/
                  </a>
                </li>
                <li>
                  <a className="text-indigo-700 underline text-lg" target="_blank" href="https://civilbsc.coj.go.th/th/content/category/detail/id/8/cid/9809/iid/177153">
                    https://civilbsc.coj.go.th/th/content/category/detail/id/8/
                  </a>
                </li>
              </ul>
            </div>
        </div>
      </div>

      <div>
        <h1>แนะนำสำหรับคุณ</h1>
        <ul className="list__post">
          <li>
            <a className="text-indigo-700 underline" href="/thai/1">
              ทายาทในกองมรดกสามารถเป็นใครได้บ้าง ?
            </a>
          </li>
          <li>
            <a className="text-indigo-700 underline" href="/thai/6">
              รูปแบบพินัยกรรม ใครสามารถทำพินัยกรรมได้บ้าง ?
            </a>
          </li>
        </ul>
      </div>
    </>
  );
};

export default MainContent;
